/**
 * General newsletter signup.
 *
 * Deliberately its own module and its own engine endpoint rather than reusing the
 * investment lead capture. That one records an accreditation attestation against a
 * securities offering and routes to investor relations; a visitor typing their address
 * into a site footer belongs nowhere near it.
 */

import { api } from './apiClient';

export type SubscribeSource = 'footer' | 'checkout' | 'event_page';

export function subscribeToNewsletter(
  email: string,
  source: SubscribeSource = 'footer',
): Promise<{ subscribed: boolean }> {
  return api.post<{ subscribed: boolean }>('/newsletter', { email, source });
}
